import {Box, Typography} from '@mui/material';
import type {QuizSessionWithScore} from '@cp/model';
import SessionsListItem from './SessionsListItem';

export interface SessionsListProps {
  sessions: (QuizSessionWithScore & {isCompleted: boolean})[];
  onSessionClick: (session: QuizSessionWithScore & {isCompleted: boolean}) => void;
}

export default function SessionsList({sessions, onSessionClick}: SessionsListProps) {
  if (sessions.length === 0) {
    return (
      <Box sx={{textAlign: 'center', py: 4}}>
        <Typography variant="h6" color="text.secondary">
          No sessions found
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{mt: 1}}>
          Start a new quiz session to see it here
        </Typography>
      </Box>
    );
  }

  return (
    <Box sx={{display: 'grid', gridTemplateColumns: {xs: '1fr', sm: 'repeat(2, 1fr)', md: 'repeat(3, 1fr)'}, gap: 2}}>
      {sessions.map((session) => (
        <SessionsListItem key={session.id} session={session} onSessionClick={onSessionClick} />
      ))}
    </Box>
  );
}
